/* PRISKEL — UX layer: section colour rhythm, current-page marking, page-loading hairline */
(function(){
  'use strict';
  var d=document, body=d.body;

  /* ---------- 1. colour rhythm: light sections take turns between white and sand ---------- */
  function rgb(s){var m=(s||'').match(/[\d.]+/g);return m?m.map(Number):null}
  function lum(c){return (0.2126*c[0]+0.7152*c[1]+0.0722*c[2])/255}
  function surface(sec){
    var list=[sec].concat([].slice.call(sec.querySelectorAll(':scope > *, :scope > * > *'),0,6));
    for(var i=0;i<list.length;i++){
      var el=list[i],cs=getComputedStyle(el);
      if(el.tagName==='LINK'||el.tagName==='SCRIPT'||el.tagName==='STYLE')continue;
      var c=rgb(cs.backgroundColor);
      if(cs.backgroundImage&&cs.backgroundImage!=='none')return {el:el,kind:'art'};
      if(c&&(c.length<4||c[3]>0.05))return {el:el,kind:lum(c)<0.6?'dark':(lum(c)>0.965?'white':'sand')};
    }
    var first=sec.firstElementChild;while(first&&/^(LINK|SCRIPT|STYLE)$/.test(first.tagName))first=first.nextElementSibling;
    return {el:first||sec,kind:'none'};
  }
  function fullBleedImage(sec){
    var r=sec.getBoundingClientRect();if(!r.height)return false;
    var imgs=sec.querySelectorAll('img,video');
    for(var i=0;i<imgs.length;i++){var ir=imgs[i].getBoundingClientRect();if(ir.width*ir.height>0.7*r.width*r.height)return true}
    return false;
  }
  function rhythm(){
    if(body.classList.contains('template-index'))return;            /* the homepage is set by hand in pk-ux.css */
    var main=d.getElementById('MainContent');if(!main)return;
    var secs=[].slice.call(main.children).filter(function(s){
      return s.classList.contains('shopify-section')&&s.offsetHeight>40&&!/apps|popup|cart|back_top/i.test(s.id);
    });
    var prev=null;
    secs.forEach(function(sec){[sec].concat([].slice.call(sec.querySelectorAll('.pk-ux-white,.pk-ux-sand,.pk-step,.pk-rv__card,.pk-sizes__tips'))).forEach(function(el){el.style.removeProperty('background-color');el.classList.remove('pk-ux-white','pk-ux-sand')})});
    secs.forEach(function(sec,i){
      var s=surface(sec);
      if(i===0||s.kind==='art'||s.kind==='dark'||fullBleedImage(sec)){
        prev=(s.kind==='white'||s.kind==='none')?'white':(s.kind==='dark'?'dark':'sand');return;
      }
      var want='white';                                                /* white first: sand is kept for cards and small accents */
      s.el.classList.remove('pk-ux-white','pk-ux-sand','pk-ux-seam');
      s.el.classList.add(want==='white'?'pk-ux-white':'pk-ux-sand');
      s.el.style.setProperty('background-color',want==='white'?'#FFFFFF':'#F4EEE6','important');  /* inline wins over section-level !important rules */
      s.el.querySelectorAll('.pk-step,.pk-rv__card,.pk-sizes__tips').forEach(function(c){c.style.setProperty('background-color',want==='white'?'#FAF7F3':'#FFFFFF','important')});
      if(prev==='white')s.el.classList.add('pk-ux-seam');
      prev=want;
    });
  }

  /* ---------- 2. mark the page you are on, everywhere it is linked ---------- */
  function current(){
    var here=location.pathname.replace(/\/$/,'')||'/';
    d.querySelectorAll('.pk-menu a[href], .pk-f2 a[href], .pk-h2x__nav a[href], #pk-hd a.pk-hd__a[href]').forEach(function(a){
      try{
        var u=new URL(a.getAttribute('href'),location.href);
        if(u.origin!==location.origin||u.hash&&u.pathname===location.pathname&&a.getAttribute('href').charAt(0)==='#')return;
        var p=u.pathname.replace(/\/$/,'')||'/';
        if(p===here&&p!=='/'&&!a.hasAttribute('aria-current'))a.setAttribute('aria-current','page');
      }catch(e){}
    });
  }

  /* ---------- 3. a fine wine-to-gold hairline while the next page loads ---------- */
  var bar=d.createElement('div');bar.className='pkux-bar';bar.setAttribute('aria-hidden','true');
  /* if the next page is slow, a quiet veil with the Priskel mark appears so the wait feels intentional */
  var veil=d.createElement('div');veil.className='pkux-veil';veil.setAttribute('aria-hidden','true');
  veil.innerHTML='<span class="pkux-veil__in"><i class="pkux-veil__m"></i><b class="pkux-veil__l"><em></em></b></span>';
  function mount(){var b=d.body||d.documentElement;b.appendChild(bar);b.appendChild(veil)}
  if(d.body)mount();else d.addEventListener('DOMContentLoaded',mount);
  var wt=0,H=d.documentElement;
  function go(){bar.classList.remove('is-go');void bar.offsetWidth;bar.classList.add('is-go');clearTimeout(wt);wt=setTimeout(function(){H.classList.add('pkux-wait')},650)}
  function stop(){bar.classList.remove('is-go');clearTimeout(wt);H.classList.remove('pkux-wait')}
  d.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href]');
    if(!a||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    if(a.target&&a.target!=='_self')return;
    if(a.hasAttribute('download')||/^(mailto|tel|sms|javascript):/i.test(a.getAttribute('href')))return;
    var u;try{u=new URL(a.href)}catch(x){return}
    if(u.origin!==location.origin)return;
    if(u.pathname===location.pathname&&u.search===location.search&&u.hash)return;
    setTimeout(function(){if(!e.defaultPrevented)go()},0);           /* drawers, sheets and quick-adds cancel the click; skip those */
  },false);
  addEventListener('pageshow',stop);addEventListener('pagehide',function(){setTimeout(stop,3000)});

  /* ---------- 4. product-page label: give it the same class names as the cards ---------- */
  function tags(){
    d.querySelectorAll('.pk-pd__tag').forEach(function(t){
      var slug=(t.textContent||'').trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
      if(slug)t.classList.add('is-'+slug);
    });
  }

  /* ---------- 5. reels play by themselves (muted) while on screen; a tap pauses and keeps it paused ---------- */
  function reels(){
    var vids=[].slice.call(d.querySelectorAll('[data-pk-autoplay] video'));
    if(!vids.length||!('IntersectionObserver' in window))return;
    vids.forEach(function(v){v.muted=true;v.setAttribute('muted','');v.setAttribute('playsinline','');
      var t=v.closest('[data-pk-autoplay]');
      v.addEventListener('play',function(){t.classList.add('is-playing')});
      v.addEventListener('pause',function(){t.classList.remove('is-playing')});
      t.addEventListener('click',function(e){if(e.target.closest('.pk-vchip,[data-pkp-snd]'))return;setTimeout(function(){if(v.paused)t.setAttribute('data-pk-held','1');else t.removeAttribute('data-pk-held')},50)});
    });
    var near=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting&&x.target.preload==='none')x.target.preload='metadata'})},{rootMargin:'600px 0px'});
    var io=new IntersectionObserver(function(en){en.forEach(function(x){
      var v=x.target,t=v.closest('[data-pk-autoplay]');
      if(x.isIntersecting&&x.intersectionRatio>=.5){if(t.hasAttribute('data-pk-held'))return;v.preload='auto';var p=v.play();p&&p.catch&&p.catch(function(){})}
      else if(!v.paused)v.pause();
    })},{threshold:[0,.5,.8]});
    vids.forEach(function(v){near.observe(v);io.observe(v)});
    d.addEventListener('visibilitychange',function(){if(d.hidden)vids.forEach(function(v){v.pause()})});
  }
  /* "In this video" on the product page: take the shopper up to the buy box */
  d.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('[data-pk-vchip-top]');if(!a)return;e.preventDefault();var t=d.querySelector('.pk-pd__info')||d.getElementById('MainContent');t.scrollIntoView({behavior:'smooth',block:'start'})});

  /* ---------- 6. product photos: a different promise on each image ---------- */
  function usps(){
    d.querySelectorAll('[data-pk-usps]').forEach(function(b){
      var list=(b.getAttribute('data-pk-usps')||'').split('|').map(function(x){return x.trim()}).filter(Boolean);if(list.length<2)return;
      var out=b.querySelector('[data-pk-usp]'),root=b.closest('[data-pkp],.pk-pd')||d,cur=root.querySelector('[data-pkp-cur]'),track=root.querySelector('[data-pkp-track]'),last=-1;
      function show(i){i=((i%list.length)+list.length)%list.length;if(i===last)return;last=i;b.classList.add('is-swap');setTimeout(function(){out.textContent=list[i];b.classList.remove('is-swap')},180)}
      function idx(){if(cur){var n=parseInt(cur.textContent,10);if(n>0)return n-1}if(track){var w=track.clientWidth||1;return Math.round(track.scrollLeft/w)}return 0}
      if(cur&&'MutationObserver' in window)new MutationObserver(function(){show(idx())}).observe(cur,{childList:true,characterData:true,subtree:true});
      if(track)track.addEventListener('scroll',function(){clearTimeout(b._t);b._t=setTimeout(function(){show(idx())},90)},{passive:true});
      show(idx());
    });
  }

  /* ---------- 7. homepage rails, the mood index and quiet reveals ---------- */
  function rails(){
    d.querySelectorAll('[data-lx-mood]').forEach(function(sec){
      var rail=sec.querySelector('[data-lx-rail]'),prev=sec.querySelector('[data-lx-prev]'),next=sec.querySelector('[data-lx-next]'),links=[].slice.call(sec.querySelectorAll('[data-lx-mood-go]'));
      if(!rail)return;var cards=[].slice.call(rail.children);
      function step(){return cards[0]?cards[0].getBoundingClientRect().width+24:rail.clientWidth}
      function sync(){var max=rail.scrollWidth-rail.clientWidth-2;if(prev)prev.disabled=rail.scrollLeft<=2;if(next)next.disabled=rail.scrollLeft>=max;var i=Math.round(rail.scrollLeft/step());links.forEach(function(l,k){l.classList.toggle('is-on',k===i)})}
      prev&&prev.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:'smooth'})});
      next&&next.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:'smooth'})});
      links.forEach(function(l){l.addEventListener('mouseenter',function(){var c=cards[+l.getAttribute('data-lx-mood-go')];if(c&&matchMedia('(min-width:990px)').matches)rail.scrollTo({left:rail.scrollLeft+c.getBoundingClientRect().left-rail.getBoundingClientRect().left,behavior:'smooth'})})});
      rail.addEventListener('scroll',function(){clearTimeout(rail._t);rail._t=setTimeout(sync,60)},{passive:true});sync();
    });
    if(!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target)}})},{threshold:.25});
    d.querySelectorAll('.lx-pf').forEach(function(s){io.observe(s)});
  }

  function init(){
    body.appendChild(bar);tags();
    rhythm();current();reels();usps();rails();
    setTimeout(rhythm,1200);                                          /* once lazy sections have settled */
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
})();
